import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { PrintLabelingVO } from './print-labeling.vo';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { PrintConverterResponse } from '@project/components/project/service/print-converter.service';

@Injectable({providedIn: 'root'})
export class PrintLabelingDataService {
  constructor(private wagoApiClient: WagoApiClient) { }

  public printLabeling(printLabelingVO: PrintLabelingVO, saveModeEnabled: boolean): Observable<string> {
    const printLabelingDTO = {
      printLabelingVO,
      saveModeEnabled
    };
    return this.wagoApiClient.post('print-labeling/', printLabelingDTO).pipe(
      map((response: any) => response.result)
    );
  }

  public exportToWSIX(printLabelingVO: PrintLabelingVO, userName: string, fileName: string, saveOnServer: boolean): Observable<string>  {
    const printLabelingWsixDTO = {
      printLabelingVO,
      fileName,
      userName,
      saveOnServer
    };
    return this.wagoApiClient.post('print-labeling/wsix/export', printLabelingWsixDTO).pipe(
      map((response: any) => response.result)
    );
  }


  public exportToWSCX(printLabelingVO: PrintLabelingVO, fileName: string, saveOnServer: boolean): Observable<string>  {
    const printLabelingWscxDTO = {
      printLabelingVO,
      fileName,
      saveOnServer
    };
    return this.wagoApiClient.post('print-labeling/wscx/export', printLabelingWscxDTO).pipe(
      map((response: any) => response.result)
    );
  }

  public exportToWSIXForFinalization(printLabelingVO: PrintLabelingVO, userName: string, fileName: string, saveOnServer: boolean): Observable<string>  {
    const printLabelingWsixDTO = {
      printLabelingVO,
      fileName,
      userName,
      saveOnServer
    };
    return this.wagoApiClient.post('print-labeling/wsix/export/finalization', printLabelingWsixDTO).pipe(
      map((response: any) => response.result)
    );
  }


  public exportToWSCXForFinalization(printLabelingVO: PrintLabelingVO, fileName: string, saveOnServer: boolean): Observable<string>  {
    const printLabelingWscxDTO = {
      printLabelingVO,
      fileName,
      saveOnServer
    };
    return this.wagoApiClient.post('print-labeling/wscx/export/finalization', printLabelingWscxDTO).pipe(
      map((response: any) => response.result)
    );
  }

  public downloadDirectPrintingPdfs(printLabelingVO: PrintLabelingVO, fileName: string): Observable<PrintConverterResponse[]> {
    const printLabelingWscxDTO = {
      printLabelingVO,
      fileName,
    };
    return this.wagoApiClient.post<PrintConverterResponse[]>('print-labeling/export/pdf', printLabelingWscxDTO, null, { overlayType: null });
  }

  public exportDirectPrintingPdfsToPdm(printLabelingVO: PrintLabelingVO, articleNumberLong: string): Observable<PrintConverterResponse[]> {
    const printLabelingWscxDTO = {
      printLabelingVO,
      articleNumberLong,
    };
    return this.wagoApiClient.post<PrintConverterResponse[]>('print-labeling/export/pdm', printLabelingWscxDTO, null, { overlayType: null });
  }
}
